import { LoginFacade } from './../../../pages/login/login.facade';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { NbMediaBreakpointsService, NbMenuService, NbThemeService } from '@nebular/theme';
import { NbDialogService } from '@nebular/theme';


import { map, takeUntil, filter, catchError, debounceTime, delay } from 'rxjs/operators';
import { Observable, throwError, Subject, forkJoin, fromEvent, BehaviorSubject, combineLatest, of } from 'rxjs';

import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../../auth.service';
import { AccountsService } from '../../../services/accounts.service';

import { AnalyticsService } from '../../../services/analytics.service';
import { PagesService } from '../../../services/pages.service';


import { MobileMessageDialog } from '../../../components/mobile-message-dialog/mobile-message-dialog.component';
import { ToasterService } from '../../../services/toaster.service';
import { EditorV4Service } from '../../../services/editorv4.service';
import { ReactDataService } from '../../../services/reactData.service';
import { ReactFacade } from '../../../facades/react.facade';


import { environment } from '../../../../environments/environment';

import * as moment from 'moment';
import { CookiesService } from '../../../services/cookies.service';
import { UsersService } from '../../../services/usersV2.service';
import { MediaService } from "../../../services/media.service";


import { MixpanelService } from '../../../services/mixpanel.service';
import {
  WIZARD_DOCPILOT_COOKIE_KEY
} from "../../../shared";

declare const Paddle;
declare const hj: any;
const { detect } = require('detect-browser');
const browser = detect();

declare global {
  interface Window {
    $editorObservables: Record<string, any>;
    $globalObservables: Record<string, any>;
    clarity: any;
  }
}

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  clickSubscription;
  userPictureOnly: boolean = false;
  userInfo: any;
  admin = false;
  administrator = false;
  adminCore = false;
  userType = 'user';
  orgId;
  orgInfo;
  viewId = null;
  accountsLoading = true;
  daysForTrialEnd = 0;
  daysForCancelAt = 0;
  showTrialEndBar = false;
  showTrialEndBarClosed = false;
  totalLiveStoriesCount: number = 1;

  trialEndedDialogOpen = false;

  showBrowserSupportMessage = false;
  hideMenu = false;
  isOffline = false;
  showRequestTeamMessage = false;
  sendingRequest = false;
  isEditorV4User = false;
  isEditPage = false;
  isShowPublishButton = false;
  isUpdateVersionButtonVisible = false;
  isVersionPublishing = false;
  isPreviewing = false;
  isPublishing$ = this.editorV4Service.isPublish$;
  isPublishTriggered = false;
  story = null;
  version = null;
  activeVersions =  []
  lastSaved = null;
  saveTimeout = null;
  isSaving: boolean = false;
  showLastSaved: boolean = true;
  showLastSavedTimeout$ = new Subject<boolean>();
  isEditorHeader$ = new BehaviorSubject<boolean>(false);
  accountCustomization$ = this.accountsService.accountCustomization$;
  isOrgAdmin: boolean;
  liveStoriesLimitCount: number;
  getStartedPreviewImage = '/assets/images/getting-start.jpg';
  isTemplateSaving$ = new BehaviorSubject<boolean>(false);
  isPro: boolean = false;
  upgradeToProTitle: string = 'Upgrading to the <strong>Pro plan</strong>';
  isCouponApplied$ = this.cookiesService.isCouponApplied$;
  currentTheme = 'default';

  isAutoSaveOn = true;
  isHistoryOpen = false;
  isMenuVisible$ = new BehaviorSubject<boolean>(false);
  isStarter: boolean;
  isTeam: boolean;
  isStarterOrTrial: boolean;
  isRestoringHistoryVersion = false;
  selectedHistoryVersionUrl = null;
  lastSavedRefreshTimeout = null;
  lastSavedHumanizedText = 'saved';
  lockedMenuItems: string[] = ['Variables'];
  isNavigator = false;
  showUpdateBillingToast: boolean = false;
  showUpdateBillingSuccessToast: boolean = false;
  actionButtonTooltip = false;

  adminRestoreVersionUrl: string = '';

  activePathName: string = window.location.pathname

  constructor(
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              public analyticsService: AnalyticsService,
              private pagesService: PagesService,
              private breakpointService: NbMediaBreakpointsService,
              public router: Router,
              private dialogService: NbDialogService,
              private ref: ChangeDetectorRef,
              private accountsService: AccountsService,
              private toasterService: ToasterService,
              private location: Location,
              private editorV4Service: EditorV4Service,
              private cookiesService: CookiesService,
              private mediaService: MediaService,
              private reactDataService: ReactDataService,
              private usersService: UsersService,
              public auth: AuthService,
              private reactFacade: ReactFacade,
              private activatedRoute: ActivatedRoute,
              private mixpanelService: MixpanelService,
              private _ngZone: NgZone,
              private loginFacade: LoginFacade) {

              }

  ngOnInit() {

    const isMobile = window.innerWidth < 1200;
    const isHeaderDisabled = this.router.url.indexOf('headerDisabled=true') > -1;
    if (isMobile && !isHeaderDisabled) {
      this.hideMenu = true;
      if (!this.isHideMobileDialog()) this.openMobileDialog();
    }
    if (isHeaderDisabled) {
      document.body.classList.add('--header-disabled');
    }
    this.accountsService.isEditorV4Org().subscribe(status => {this.isEditorV4User = status;});
    this.editorV4Service.editorV4Status$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isEditorV4User = data;
      if (!this.isEditorLink) {
        this.isEditorV4User = false;
      }
      if(this.isEditorV4User) {
        this.addEditorV4Class();
        hj('event', 'EditorV4');
      }
    });

    this.currentTheme = this.themeService.currentTheme;
    // this.initClickListener();
    this.auth.getOrgId$().subscribe(orgId => this.orgId = orgId);
    this.auth.getNavigator$().subscribe(isNavigator => this.isNavigator = isNavigator);
    this.auth.getAdminCore$().subscribe(admin => {
      this.adminCore = (admin === true)
      if(typeof(hj) === 'function') hj('event', 'No admin core');
    })
    this.userType = this.auth.userType;
    forkJoin([
      this.accountsService.info(),
      this.auth.isAdministrator$()
    ])
    .subscribe(([orgInfo, isAdmin]) => {
      this.orgInfo = orgInfo;
      this.loadEditorV4Files();
      this.setTestingGroupClass();
      this.updateMobileOnboardingCompleted();
      this.handleDocpilotFlow();
      if(this.orgInfo.parameters && this.orgInfo.parameters.isEditorV4) this.isEditorV4User = true;
      const utms = this.loginFacade.getUtmData();
      if (utms) {
        this.accountsService.updateOrgParameters(utms).subscribe();
        for (const [key, value] of Object.entries(utms)) {
          this.analyticsService.register(key, value);
        }
      }
      if (this.orgInfo.customization) this.accountsService.updateAccountCustomization(this.orgInfo.customization);
      this.checkFreeTrialEnd(orgInfo);
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.checkFreeTrialEnd(orgInfo);
        }
      });
      if(typeof(hj) === 'function') {
        orgInfo.isSelfServ ? hj('event', 'Self Serve') : hj('event', 'B2B');
      }
      this.loadHubspotChat();
      this.isPro = this.accountsService.isPro;
      this.isStarterOrTrial = this.accountsService.isStarterOrTrial;
      this.isStarter = this.accountsService.isStarter;
      this.isTeam = this.accountsService.isTeam;
      if((!this.accountsService.isPaid || !!this.orgInfo.cancelAt) && !this.router.url.includes('/pages/wizard')) this.actionButtonTooltip = true;
    });
    this.auth.isAdmin$().subscribe(admin => {
      this.admin = admin === true;
      this.editorV4Service.isStorydocAdmin$.next(this.admin);
    })
    this.auth.isAdministrator$().subscribe(administrator => this.administrator = (administrator === true));
    this.isEditPage = this.isEditorLink;
    this.router.events.subscribe((val) => {
      this.isEditPage = this.isEditorLink;
    });
    this.auth.getUser$()
      .subscribe(user => {
        this.auth.updateCurrentUser(user);
        if(typeof(hj) === 'function') hj('event', user.sub);
      });
    this.usersService.getCurrentUser$().subscribe(user => this.userInfo = user);
    this.editorV4Service.showPublishButtonStatus$.pipe(takeUntil(this.destroy$)).subscribe(data => this.isShowPublishButton = !!data);

    this.editorV4Service.showToast$.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast) {
        this.toasterService.showToast(toast.type, toast.title, toast.body, toast.config);
      }
    });


    this.editorV4Service.walkthrough$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (!data) return
      if (!['skip_tour', 'view_step'].includes(data.type)) return;
      const hasSkipped = data.type === 'skip_tour';

      const newWalkthrough = {
        hasSkipped: hasSkipped,
        lastStepIndex: data.stepIdx
      }

      this.usersService.updateWalkthrough(newWalkthrough).pipe(catchError(err => {
        this.track('failed to update walkthrough on user', {
          'failure message': err.message
        })
        return throwError(err)
      })).subscribe(res => {
        this.usersService.currentUser$.next({
          ...this.usersService.currentUser$.getValue(),
          walkthrough: newWalkthrough
        })
      });
    });

    this.showLastSavedTimeout$.pipe(takeUntil(this.destroy$), debounceTime(2000)).subscribe(() => {
      this.showLastSaved = true;
      this.ref.detectChanges();
    });
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.showBrowserSupportMessage = browser.name === 'firefox' || browser.name === 'safari';

    window.addEventListener("offline", (event) => {
      this.isOffline = true;
    });

    window.addEventListener("online", (event) => {
      this.isOffline = false;
    });
    this.getTotalLiveStoriesCount();
    this.screenResizeListener();
    this.urlChangeListener();
    this.checkURL();

    this.auth.getUserType$().pipe(takeUntil(this.destroy$)).subscribe(userType => {
      this.reactDataService.userRole$.next(userType);
    });
    fromEvent(document, 'settingsRenderAngular').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      const { action, variable, story, url } = event.detail;
      this.trackStory('success get event from react', {
        'event action': event.detail.action
      }, story);
    });
    fromEvent(document, 'navigateByUrl').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      const {path, payload} = event.detail;
      if (path) {
        if (path === '/pages/help' && payload) {
          sessionStorage.setItem('help-center-data', JSON.stringify(payload));
        }
        return this.navigateByUrl(path);
      }
    });
    fromEvent(document, 'sd-location-replace-state').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      const { path } = event.detail;
      if (path) {
        this.location.replaceState(path);
      }
    });
    fromEvent(document, 'firstVersionCreated').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      if (event.detail.version) {
        this.firstVersionCreation();
      }
    });

    fromEvent(document, 'updateOrgInfo').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      if (event.detail.account) {
        return this.accountsService.updateOrgInfo(event.detail.account);
      }
    });

    fromEvent(document, 'updatePlanPropertiesInfo').pipe(takeUntil(this.destroy$)).subscribe((event: CustomEvent) => {
      if (event.detail.trigger) {
        this.analyticsService.updatePlanPropertiesInfo(
          event.detail.trigger,
          event.detail.value,
          event.detail.action,
          event.detail.payload
        );
      }
    });

    fromEvent(document, 'sd-track').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { event, params = {} } = e.detail;
      if(!event) return;
      this.analyticsService.track(event, params);
    })

    fromEvent(document, 'sd-track-story').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { event, page, params = {} } = e.detail;
      if (!event) return;
      const isPage = page && typeof page === 'object' && page._id;
      if (event && !isPage) return this.analyticsService.track(event, params);
      this.analyticsService.trackStory(event, page, {
        ...params
      });
    })

    fromEvent(document, 'sd-track-version').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { event, page, version, params = {} } = e.detail;
      if (!event) return;
      if (!version && page) return this.analyticsService.trackStory(event, page, params);
      if(!page || !version) return;
      this.analyticsService.trackVersion(event, page, version, {
        ...params
      });
    })

    fromEvent(document, 'sd-register-property').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { property, value } = e.detail;
      this.analyticsService.register(property, value);
    })

    fromEvent(document, 'sd-hubspot-event').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { event, payload = {} } = e.detail;
      this.analyticsService.sendHubspotInternalEvent(event, payload);
    })

    fromEvent(document, 'sd-hubspot-property').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { payload = {} } = e.detail;
      this.analyticsService.sendHubspotProperty(payload);
    })
    fromEvent(document, 'sd-navigate-versions-page').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
       const { payload = {} } = e.detail;
      this.router.navigateByUrl(`pages/editor/${payload.id}/versions`)
    })

    fromEvent(document, 'sd-user-menu-action').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      const { action } = e.detail;
      this.onMenuItemClick(action);
    })

    fromEvent(document, 'sd-logout').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      this.mixpanelService.reset();
      this.auth.logout();
    })

    fromEvent(document, 'sd-restart-session').pipe(takeUntil(this.destroy$)).subscribe((e: CustomEvent) => {
      this.auth.login();
    })

    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const { subject, topic, help } = params;
      if(!help) return;
      if (subject && topic) this.openHelpCenter({ subject, topic });
      else this.openHelpCenter({});
    });

    this.editorV4Service.analyticsEvent$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (!data) return;
      const properties = { ...data.params };
      delete properties.screen;
      if ((data.params.screen || '').includes('share-dialog')) {
        if (data.type === 'story') {
          const { page } = data;

          if (page && page.settings) {
            this.analyticsService.trackStory(data.event, page, properties);
          }
        }

        if (data.type === 'version') {
          const { page, version } = data;
          const versionData = version || this.version;

          if (page && page._id && versionData && versionData.data && versionData.data.title) {
            this.analyticsService.trackVersion(data.event, page, versionData, properties);
          }
        }
      }

      if (data.type === 'common') {
        this.analyticsService.track(data.event, properties);
      }
      if (data.type === 'send-hubspot-internal-event') {
        this.analyticsService.sendHubspotInternalEvent(data.event, data.payload);
      }
      if (data.type === 'send-hubspot-property') {
        this.analyticsService.sendHubspotProperty(data.payload);
      }
    });



    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.activePathName = val.url
        this.ref.detectChanges();
      }
    })
  }

  openHelpCenter(data) {
    sessionStorage.setItem('help-center-data', JSON.stringify(data));
    this.router.navigateByUrl("/pages/help");
  }

  firstVersionCreation() {
    const isCreatedAfterApril26 = (new Date(this.orgInfo.createdAt).getTime() > new Date('2022-04-26T00:00:00.000+00:00').getTime());
    if((this.orgInfo && this.orgInfo.firstVersionCreated) || !isCreatedAfterApril26) return
    this.accountsService.firstVersionCreation()
      .pipe(
        catchError((err: any) : Observable<any> => {
          this.trackStory('failed account data update', {
            'failure message': err.message
          });
          return throwError(err);
        })
      )
      .subscribe(info => {
        this.orgInfo = info;
        this.accountsService.updateOrgInfo(this.orgInfo);
        this.analyticsService.sendHubspotInternalEvent('first version created');
      })
  }

  ngAfterViewInit() {
    if (this.router.url.indexOf('headerDisabled=true') <= -1) return;
    const body = document.getElementsByTagName('body');
    if (body.length) body[0].classList.add('header-disabled');
  }

  loadEditorV4Files() {
    const isDev: boolean = false;
    const date: Date = new Date();
    let randomNumber: string = date.toISOString();
    let bundleJs: string, bundleCss: string;
    window.$editorObservables = this.editorV4Service;
    const DEV_MODE = environment.env !== 'production' && isDev;

    if(DEV_MODE) {
      bundleJs = `http://localhost:3000/static/js/bundle.js?${randomNumber}`;
    } else {
      bundleJs = `${environment.betaEditorURL}/static/js/bundle.min.js?${randomNumber}`;
      bundleCss = `${environment.betaEditorURL}/static/css/main.min.css?${randomNumber}`;
    }



    //bundleCss
    if(bundleCss) {
      let editorV4Style = document.createElement("link");
      editorV4Style.href = bundleCss;
      editorV4Style.type = 'text/css';
      editorV4Style.rel = 'stylesheet';
      document.head.append(editorV4Style);
    }

    //bundleJs
    let editorV4script = document.createElement("script");
    editorV4script.src = bundleJs;
    document.body.append(editorV4script);
    this.initializeReactApp();
  }

  navigateByUrl (url: string) {
   return this.router.navigateByUrl(url);
  }

  initializeReactApp() {
    this.reactFacade.initializeApp$().subscribe(() => {
      window.$globalObservables = this.reactDataService;
      document.dispatchEvent(new CustomEvent('initialize-react-app'));
    });
  }

  get isEditorLink() {
    return /\d/.test(this.router.url)
      && this.router.url.indexOf('editor/folder/') === -1
      && this.router.url.indexOf('/versions') <= -1
  }

  urlChangeListener() {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.checkURL();
      document.dispatchEvent(new CustomEvent('sd-url-change', { detail: { url: this.router.url } }));
    });
  }

  checkURL() {
    this.handleOpenMobileMessageDialog();
    if (this.router.url.indexOf('/pages/wizard') > -1) this.actionButtonTooltip = false;
    if(/^(?!.*(?:variables|versions|preview|folder|templates))(\/pages\/editor\/[a-zA-Z0-9]+(\/[a-zA-Z0-9]+)?(\?[^ ]+)?)$/.test(this.router.url)) {
      this.isEditorHeader$.next(true)
    } else this.isEditorHeader$.next(false)
    this.handleScreenGlobalProperty()
  }

  addEditorV4Class() {
    this.isEditorHeader$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (value) {
        document.body.classList.add('editorv4');
        document.querySelector('.scrollable-container').classList.add('editorV4');
      } else {
        document.body.classList.remove('editorv4');
      }
    })
  }

  handleScreenGlobalProperty() {
    const url = this.router.url
    let screen = {
      '/pages/analytics': 'analytics',
      '/pages/profile/integrations': 'integrations',
      '/pages/profile/plans': 'pricing',
      '/pages/profile/subscription': 'subscription',
      '/pages/profile/users': 'users',
      '/pages/profile/invoices': 'invoices',
      '/pages/profile/automations': 'automations',
      '/pages/profile/add-ons': 'add-ons',
      '/pages/editor': 'library',
      '/pages/editor/variables': 'variables',
      '/pages/editor/templates': 'templates',
      '/pages/help': 'help',
      '/pages/wizard': 'wizard',
      '/pages/home': 'home',
    }[ url ];


    if (screen) {
      this.analyticsService.register('screen', screen);
      return;
    }

    if (url.match(/^\/pages\/profile\/integrations(\/.*)?$/)) {
      screen = 'integrations';
    }

    if (url.match(/^\/pages\/editor(\/.*)?$/)) {
      if(url.includes('/folder/')) screen = 'folder';
      else screen = 'editor';
    }

    this.analyticsService.register('screen', screen || 'home');
  }

  updateMobileOnboardingCompleted() {
    if(window.innerWidth > 1200 && this.orgInfo.mobileOnboardingStartedAt && !this.orgInfo.mobileOnboardingCompletedAt) {
      this.accountsService.setMobileOnboardingCompleted()
        .pipe(catchError(() => of(null)))
        .subscribe((account) => {
          if(account) this.accountsService.updateOrgInfo(account);
        });
    }
  }

  handleDocpilotFlow() {
    // Only proceed if on desktop and mobile docpilot onboarding was started but not completed
    if (window.innerWidth > 1200 &&
        this.orgInfo.mobileDocpilotOnboardingStartedAt &&
        !this.orgInfo.mobileDocpilotOnboardingCompletedAt) {

      // Mark mobile docpilot onboarding as completed to prevent future redirects
      this.accountsService.setMobileDocpilotOnboardingCompleted()
        .pipe(
          catchError(error => {
            console.error('Failed to set mobile docpilot onboarding completed:', error);
            return of(null);
          })
        )
        .subscribe(account => {
          if (account) {
            this.accountsService.updateOrgInfo(account);

            // Set the docpilot cookie which will be used by the wizard inside ngx-wizard-page component
            const docpilotPayload = this.orgInfo.docpilotPayload;
            if (docpilotPayload && typeof docpilotPayload === 'object') {
              try {
                this.cookiesService.setCookie(WIZARD_DOCPILOT_COOKIE_KEY, JSON.stringify(docpilotPayload), 1);

                // Only redirect after cookie is set
                setTimeout(() => {
                  this.router.navigateByUrl('/pages/wizard');
                }, 100);
              } catch (e) {
                console.error('Failed to set docpilot cookie:', e);
              }
            }
          }
        });
    }
  }

  openMobileDialog() {
    if (!document.querySelector('#small-screen-dialog')) {
      this.dialogService.open(MobileMessageDialog, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
      })
    }
    this.analyticsService.track('view wizard on mobile device notification');
  }

  onUserMenuClick() {
    this.isMenuVisible$.next(!this.isMenuVisible$.value);
    this.ref.detectChanges();
  }

  closeMenu () {
    this.isMenuVisible$.next(false);
  }

  onMenuItemClick(action: string) {
    // this.analyticsService.track('click user menu', {'item name': action});
    switch (action) {
      // case 'profile': {
      //   this.analyticsService.track('click profile page', { placement: 'user menu' });
      //   this.dialogService.open(AccountComponent, { context: {} }).onClose.subscribe((status) => {
      //     if (!status) return;
      //     document.dispatchEvent(new CustomEvent('sd-invalidate-tags', { detail: { tags: [{ type: 'Users', id: 'CURRENT' }] } }));
      //   })
      //   break;
      // };
      // case 'invite-team': {
      //   this.router.navigateByUrl('/pages/profile/users');
      //   break;
      // };
      // case 'settings': {
      //   this.dialogService.open(AccountCustomizationDialogComponent, { context: {} })
      //   .onClose.subscribe(orgInfo => {
      //     if (!orgInfo) return;
      //     this.orgInfo = orgInfo;
      //   });
      //   break;
      // };
      // case 'my-plan': {
      //   this.router.navigateByUrl('/pages/profile/subscription');
      //   break;
      // };
      // case 'variables': {
      //   this.router.navigateByUrl('/pages/editor/variables');
      //   this.track('click variables page', { placement: 'user menu' });
      //   break;
      // };
      // case 'media-library': {
      //   document.dispatchEvent(new CustomEvent('sd-open-media-library-dialog', { detail: {} }));
      //   break;
      // };
      // case 'admin-settings': {
      //   this.openAdminCustomizationDialog();
      //   break;
      // };
      // case 'restart-session': {
      //   this.auth.login();
      //   break;
      // };
      // case 'notion-deployment': {
      //   this.openAdminDataPublishDialogComponent();
      //   break;
      // };
      // case 'delete-account': {
      //   this.deleteAccount();
      //   break;
      // };
      // case 'logout': {
      //   this.mixpanelService.reset();
      //   this.auth.logout();
      //   break;
      // };
    }
    this.isMenuVisible$.next(false);
  }

  // initClickListener() {
  //   this.clickSubscription = this.menuService.onItemClick()
  //   .pipe(
  //     filter((obj: any) => obj.tag === 'userMenu')
  //   )
  //   .subscribe((item: any) => {
  //     this.analyticsService.track('click user menu', {'item name': item.item.title});
  //     if(item.item.data.link){
  //       if(item.item.data.target) return window.open(item.item.data.link, item.item.data.target);
  //       this.router.navigateByUrl(item.item.data.link);
  //     } else if(item.item.data.media) {
  //       document.dispatchEvent(new CustomEvent('sd-open-media-library-dialog', { detail: {} }));
  //     } else if(item.item.data.refreshSession) {
  //       // this.auth.login();
  //     } else if (item.item.data.adminCustomization) {
  //       // this.openAdminCustomizationDialog();
  //     } else if(item.item.data.customize) {
  //       // this.dialogService.open(AccountCustomizationDialogComponent, {
  //       //   closeOnBackdropClick: false,
  //       //   closeOnEsc: false,
  //       //   context: { }
  //       // }).onClose.subscribe(orgInfo => {
  //       //   if (!orgInfo) return;
  //       //   this.orgInfo = orgInfo;
  //       // });
  //     } else if(item.item.data.handleHelp) {
  //       this.handleHelpButton();
  //     } else if (item.item.data.account) {
  //       // this.dialogService.open(AccountComponent, {context: { }})
  //     }
  //   });
  // }


  checkFreeTrialEnd(orgInfo) {
    if (window.localStorage.getItem('updatedBilling') === 'true') {
      this.showUpdateBillingSuccessToast = true;
      this.ref.detectChanges();
    }

    this.orgInfo = orgInfo;
    if(orgInfo.analyticsViewId) this.viewId = orgInfo.analyticsViewId;
    const excludeRegex = /^\/pages\/(profile\/(plans|users|subscription|invoices)|help)/;
    if(orgInfo.plan === 'trial' && orgInfo.trialEnd) {

      const now = moment(new Date()); //todays date
      const end = moment(orgInfo.trialEnd); // another date
      const duration = moment.duration(end.diff(now));
      const days = duration.asDays();
      if (days <= 0) {
        if (this.trialEndedDialogOpen) return;
        this.trialEndedDialogOpen = true;
        this.showTrialEndBar = true;
        this.analyticsService.sendHubspotProperty({ trial_status: 'expired' });
        this.analyticsService.sendHubspotInternalEvent('trial status expired');
        this.addTrialEndedClass();

        this.daysForTrialEnd = 0;
        if(!this.orgInfo.postTrialVisit) this.postTrialVisitDate();
        this.track('trial ended header', {
          action: "view",
          'days since trial ended': Math.abs(days)
        });
      } else {
        this.daysForTrialEnd = parseInt(days.toString()) + 1;
        this.showTrialEndBar = false;
      }
    } else if(this.orgInfo.plan === 'paid') {
      if (this.orgInfo.cancelAt) {
        const now = moment(new Date());
        const end = moment(this.orgInfo.cancelAt);
        const duration = moment.duration(end.diff(now));
        const days = duration.asDays();
        this.daysForCancelAt = parseInt(days.toString()) + 1;

        if (excludeRegex.test(this.router.url)) return;
        const isExpired = end.diff(now) < 0;
        if(!isExpired || this.router.url.indexOf('/help') > -1) return;

        this.areYouSureSubscriptionDialog();
      } else if (this.orgInfo.subscriptionStatus === 'past_due') {
        this.showUpdateBillingToast = true;
        this.ref.detectChanges();
      } else if (this.orgInfo.subscriptionStatus === 'paused') {
        if (excludeRegex.test(this.router.url)) return;
        if(this.router.url.indexOf('/help') > -1) return;

        this.reactFacade.openDialog({
          id: 'account-is-on-hold',
        })
      }
    }
  }

  addTrialEndedClass() {
    const body = document.getElementsByTagName('body');
    if (body.length) body[0].classList.add('--trial-ended');
  }

  postTrialVisitDate() {
    const isCreatedAfterApril26 = (new Date(this.orgInfo.createdAt).getTime() > new Date('2022-04-26T00:00:00.000+00:00').getTime());
    if (!isCreatedAfterApril26) return;
    this.accountsService.postTrialVisitDate()
    .pipe(
      catchError((err: any) : Observable<any> => {
        return throwError(err);
      })
    )
    .subscribe(info => {
      this.orgInfo = info;
      this.accountsService.updateOrgInfo(this.orgInfo);
      const date = moment(new Date()).utc().startOf('day');
      this.analyticsService.sendHubspotInternalEvent('post trial visit', { date: moment().format('DD/MM/YYYY hh:mm') });
      this.analyticsService.sendHubspotProperty({ post_trial_visit_date: date.valueOf() });
    })
  }

  areYouSureSubscriptionDialog() {
    this.reactFacade.openDialog({
      id: 'plan-has-been-cancelled'
    })
  }

  subscriptionExpiredFoundContact() {
    const data = {
      topic: 'Billing and plans',
      subject: 'Re-activate my account'
    }
    sessionStorage.setItem('help-center-data', JSON.stringify(data));
    this.router.navigateByUrl('/pages/help');
  }


  getCouponCode() {
    const code = this.cookiesService.getCookie('sd-paddle-coupon');
    return code ? code : null;
  }

  checkCanceledSubscription() {
    if(!this.orgInfo || !this.orgInfo.cancelAt) return

  }

  get dialogClosingParams() {
    return this.adminCore ? {} : {
      closeOnBackdropClick: false,
      closeOnEsc: false,
    }
  }

  ngOnDestroy() {
    if (this.lastSavedRefreshTimeout != null) {
      clearInterval(this.lastSavedRefreshTimeout)
    }

    this.destroy$.next();
    this.destroy$.complete();
    this.analyticsService.unsubscribe();
    if(this.clickSubscription) this.clickSubscription.unsubscribe();
  }

  changeOrgId(id: string) {
    this.auth.setOrgId(id);
    this.updateURLState();
    this.updateSearchParams();
    this.mixpanelService.reset();
    window.location.reload();
  }

  updateSearchParams() {
    const COOKIE_KEY = "sd-stories-filters";
    const current = localStorage.getItem(COOKIE_KEY);
    if (!current) return;
    const currentFilters = JSON.parse(current);
    delete currentFilters['folder'];
    localStorage.setItem(COOKIE_KEY, JSON.stringify(currentFilters));
  }

  updateURLState() {
    if(!this.location.path().includes('folder')) return
    this.location.replaceState('/pages/editor');
  }

  changeUserType(value) { // src/app/auth.service.ts
    this.auth.userType = value;
    window.location.reload();
  }

  clickHeaderSubscribeNow() {
    this.subscribeNow("header action button");
  }

  get ignoreSubscribeNow() {
    return this.adminCore && this.admin;
  }

  subscribeNow(trigger: string) {
    this.track("pricing page", { trigger });
    this.router.navigateByUrl('/pages/profile/plans');
  }

  openAdminCustomizationDialog() {
    document.dispatchEvent(new CustomEvent('sd-trigger-dialog', {
      detail: {
        id: 'uZknTZTeNMV3lZSLhBSKR'
      }
    }));
  }

  loadHubspotChat() {
    const chat = document.getElementById('hubspot-messages-iframe-container');
    if (chat && (!this.accountsService.isB2B ||  this.accountsService.isAppSumo)) return chat.classList.add('hidden');
  }



  get subscriptionTitle() {
    if(!this.orgInfo) return "Loading..."
    if(this.orgInfo.plan === 'trial') {
      return 'Free trial'
    } else {
      const plan = environment.paddle.plans.find(plan => plan.id === this.orgInfo.subscriptionPlanId);
      if(!plan || !plan.title) return "No plan found";
      return `
      Active ${plan.title} subscription,
      next payment on ${new Date(this.orgInfo.nextPayment).toLocaleDateString("en-US")}
      `;
    }
  }

  get plan() {
    if(!this.orgInfo || !this.orgInfo.subscriptionPlanId) return null;
    return environment.paddle.plans.find(plan => plan.id === this.orgInfo.subscriptionPlanId);
  }

  get showSubscribeNow() {
    return this.orgInfo && this.orgInfo.plan === 'trial';
  }

  get showSettingsButton() {
    if(!this.orgInfo) return false;
    return this.administrator && this.orgInfo; //  b2b & b2c can see this link. && (this.orgInfo.isSelfServ !== true || this.adminCore);
  }

  get showSubscriptionBadge() {
    return this.orgInfo && this.orgInfo.plan && this.orgInfo.subscriptionPlanId;
  }

  get isTestGroupA() {
    return this.accountsService.isAGroup;
  }

  handleHelpButton() {
    this.analyticsService.sendHubspotInternalEvent('clicked help', { date:  moment().format('DD/MM/YYYY hh:mm')});
    this.analyticsService.sendHubspotProperty({ clicked_help_date:  moment(new Date()).utc().startOf('day').valueOf() });
    return this.router.navigateByUrl('/pages/help');
  }

  handleOpenMobileMessageDialog() {
    if (window.innerWidth <= 1200 && !document.querySelector('#small-screen-dialog') && !this.isHideMobileDialog()) {
      this.dialogService.open(MobileMessageDialog, {
        closeOnEsc: false,
        closeOnBackdropClick: false
      });
      document.body.style.overflow = 'hidden';
    }
  }

  screenResizeListener() {
    if(this.isHideMobileDialog()) return;
    fromEvent(window, 'resize').pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe(() => this.handleOpenMobileMessageDialog());
  }
  isHideMobileDialog() {
    return [ '/pages/wizard', '/pages/analytics', '/pages/integrations/hubspot-iframe' ].includes(window.location.pathname);
  }

  get showRejoinButton() {
    if(!this.orgInfo) return false;
    const isCancel = !!this.orgInfo.cancelAt;
    return isCancel && moment(this.orgInfo.cancelAt).diff(moment(), 'days') < 30;
  }

  // ================== Editor V4 functions ==================

  track(event, params = {}) {
    this.analyticsService.track(event, {
      ...params
    });
  }
  trackStory(event, params = {}, storyFromReact = null) {
    let storyData = this.story;

    if (storyFromReact !== null) {
      storyData = storyFromReact;
    }

    if (this.version) {
      this.analyticsService.trackVersion(event, storyData, this.version, {
        ...params
      });
    } else {
      this.analyticsService.trackStory(event, storyData, {
        ...params
      });
    }
  }

  getTotalLiveStoriesCount() {
    this.pagesService.count({status: 'Live'})
    .pipe(
      delay(5000),
      catchError((err: any) : Observable<any> => {
        return throwError(err);
      })
    ).subscribe(res => this.totalLiveStoriesCount = res.count === 0 ? 0 : 1);
  }

  setCookie(name: string, value: boolean, days: number) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }


  closeUpdateBillingToast() {
    this.showUpdateBillingToast = false;
    this.ref.detectChanges();
  }

  closeUpdateBillingSuccessToast() {
    this.showUpdateBillingSuccessToast = false;
    this.ref.detectChanges();
  }

  closeUpgradeButtonTooltip() {
    this.actionButtonTooltip = false;
  }

  setTestingGroupClass() {
    // disabled the AB test group
    const design = (this.isTestGroupA && false) ? '--sd-group-a' : '--sd-group-b';
    const root = document.documentElement;

    const proDesignSystem = {
      '--sd-group-a': {
        '--pro-main-color': '#FFB82E',
        '--pro-border-color': '#FFB82E',
        '--pro-background-light': '#fffaf1',
        '--pro-background-border-color': 'rgba(253, 185, 54, 0.2)',
        '--pro-background-dark': 'rgba(255, 184, 46, 0.3)',
        '--pro-text-color': '#12033e',
      },
      '--sd-group-b': {
        '--pro-main-color': '#FF7613',
        '--pro-border-color': '#D9620C',
        '--pro-background-light': '#fff1e7',
        '--pro-background-border-color': '#fff1e7',
        '--pro-background-dark': '#ffcca7',
        '--pro-text-color': '#FFFFFF',
      },
    };

    Object.entries(proDesignSystem[ design ])
      .forEach(([ key, value ]: [ string, string ]) => {
        root.style.setProperty(key, value);
      });
  }

  // ================== End of editor V4 functions ==================

}
